import React from 'react';
import { FormGroup } from 'react-bootstrap';
import { isBoolean } from 'lodash';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { customStyles } from '../helper';

export function Status(props) {
  const { statusColours, rowIndex, colIndex, onChange, gridY, CustomAddEditAccess, isProductArchived } = props;
  const defaultColor = statusColours.find((eleColor) => eleColor?.setDefault === true);
  const { t } = useTranslation('common');

  const selectStyle = {
    ...customStyles,
    control: () => ({
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      // height: "100%",
      minHeight: 20,
      border: '1px solid #848484',
      backgroundColor: props?.value?.colourHexCode || defaultColor?.colourHexCode,
      color: '#FFF',
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.7 : 1;
      return { ...provided, opacity, color: '#000', fontSize: 14 };
    },
    option: (styles, { data, isSelected }) => {
      const foundStatus = statusColours?.find((status) => status.colourName === data.colourName);
      return {
        ...styles,
        color: isSelected ? '#000' : foundStatus?.colourHexCode,
        backgroundColor: isSelected ? foundStatus?.colourHexCode : 'white',
      };
    },
    valueContainer: (provided) => ({
      ...provided,
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0px 2px',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: '#aaa', // Custom colour
      padding: '2px 2px',
      svg: {
        width: '18px',
        height: '18px',
      },
    }),
  };
  return (
    <FormGroup className="mb-0 h-100 flex-fill position-relative">
      <div className="custom-react-select-po h-100">
        <Select
          options={statusColours}
          getOptionLabel={(option) => `${option?.colourName}`}
          getOptionValue={(option) => `${option?.colourHexCode}`}
          isDisabled={(isBoolean(CustomAddEditAccess) ? !CustomAddEditAccess : false) || isProductArchived}
          inputProps={{
            autoComplete: 'off',
            autoCorrect: 'off',
            spellCheck: 'off',
          }}
          menuPlacement={gridY > 10 ? 'top' : 'bottom'}
          className="h-100"
          classNamePrefix="react-select-status"
          styles={selectStyle}
          placeholder={t('COMMON_DROP_DOWN.STATUS')}
          value={props?.value || defaultColor}
          onChange={(e) => onChange(e, rowIndex, colIndex)}
        />
      </div>
    </FormGroup>
  );
}
export default Status;
